var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOurVision(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64.23,
    height: 64.23,
    viewBox: "0 0 64.23 64.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:#002173}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "strategy_1_",
    "data-name": "strategy (1)",
    transform: "translate(-26 -26.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15506",
    fill: "#cedbfc",
    d: "M40.464 128.858a25.822 25.822 0 0 1 23.214-25.695c-.861-.085-1.727-.128-2.605-.129a25.824 25.824 0 1 0 2.6 51.518 25.821 25.821 0 0 1-23.209-25.694z",
    "data-name": "Path 15506",
    transform: "translate(-7.97 -66.277)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15507",
    d: "M53.507 147.014a27.509 27.509 0 0 0 22-44.023.977.977 0 1 0-1.562 1.175 25.549 25.549 0 1 1-5.1-5.1.977.977 0 1 0 1.175-1.562 27.508 27.508 0 1 0-16.516 49.506z",
    className: "cls-2",
    "data-name": "Path 15507",
    transform: "translate(0 -56.783)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15508",
    d: "M116.589 157.017a.977.977 0 0 0-.215-1.365 19.126 19.126 0 1 0 4.248 4.253.977.977 0 0 0-1.582 1.148 17.172 17.172 0 1 1-3.816-3.821.977.977 0 0 0 1.365-.215z",
    className: "cls-2",
    "data-name": "Path 15508",
    transform: "translate(-51.622 -108.405)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15509",
    d: "M191.166 253.955a.977.977 0 0 0 0-1.955 5.166 5.166 0 1 0 5.166 5.166.977.977 0 0 0-1.955 0 3.212 3.212 0 1 1-3.212-3.212z",
    className: "cls-2",
    "data-name": "Path 15509",
    transform: "translate(-137.659 -194.443)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15510",
    fill: "#f0b33f",
    d: "M252.819 35.879l-8.187-.81-.81-8.187a.977.977 0 0 0-1.664-.595L231.3 37.148a.977.977 0 0 0-.257.928l1.841 7.361-16.6 16.6a.977.977 0 0 0 1.382 1.382l16.6-16.6 7.362 1.84a.977.977 0 0 0 .928-.257l10.86-10.86a.977.977 0 0 0-.595-1.664zm-19.748 2.26l9.009-9.009.64 6.469-8.227 8.227zm8.491 8.491l-5.687-1.422 8.227-8.227 6.469.64z",
    "data-name": "Path 15510",
    transform: "translate(-163.47)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOurVision);
export default __webpack_public_path__ + "static/media/our-vision.7c1f65ab68e63f91e16de5f7b4ba6110.svg";
export { ForwardRef as ReactComponent };